// Feature keys from the Super Admin's Feature Access Control (backend/feature_access.py) used by the dashboards.
// The API refuses what a company's plan doesn't include; the dashboards hide it.

/** Business Basic dashboard sections -> the feature each needs. Sections not listed are always shown. */
export const BASIC_SECTION_FEATURES = {
  '/phone-numbers': 'business_phone_number',
  '/call-flows': 'call_flows',
  '/calls': 'call_history',
  '/recordings': 'call_recording',
  '/contacts': 'contacts',
  '/appointments': 'appointments',
  '/campaigns': 'campaigns',
  '/analytics': 'analytics',
  '/team': 'team',
};

export const FEATURE_NAMES = {
  business_phone_number: 'Business Phone Number',
  click_to_call: 'Click-to-Call',
  call_recording: 'Call Recording',
  call_history: 'Call History & Analytics',
  call_flows: 'Call Flow Builder',
  ai_receptionist: 'AI Receptionist',
  team: 'Team Management',
  contacts: 'Contacts & CRM',
  appointments: 'Appointments',
  campaigns: 'Campaigns & Automation',
  analytics: 'Advanced Analytics',
};
